import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { MdLocationOn } from 'react-icons/md';
import ClientManagerCard from '../../Component/ClientManagerCard';
import HeadingWithUnderline from '../../Component/HeadingWithUnderline';
import Tabs from '../../Component/Tabs';
import {
  map1,
  map3,
  MapMarkerIcon,
  PhotoIcon,
  StreetViewIcon,
  VideoIcon
} from '../../constant/imagePath';
import classes from './EventDetail.module.css';

import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { AiFillHeart, AiFillInfoCircle, AiOutlineHeart } from 'react-icons/ai';
import { BsDownload, BsShareFill } from 'react-icons/bs';
import { TbCalendarTime } from 'react-icons/tb';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import { toast } from 'react-toastify';
import BannerImageAd from '../../Component/BannerImageAd';
import Button from '../../Component/Button/Button';
import DetailPageHeroSection from '../../Component/DetailPageHeroSection';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import IconList from '../../Component/IconList/IconList';
import { Loader } from '../../Component/Loader';
import RenderBreadcrum from '../../Component/RenderBreadcrum';
import ShareModal from '../../Component/ShareModal/ShareModal';
import { downloadFileFromURL } from '../../Helper/downloadFile';
import { restrictOnlyUserActions } from '../../Helper/restrictActions';
import { imageUrl, pdfUrl } from '../../config/apiUrl';
import { eventsData } from '../../constant/commonData';
import {
  useFavoriteEntityMutation,
  useGetPublicEventsDetailQuery
} from '../../store/apiSlice/apiSlice';
import { usdToOther } from '../../utils/helpers';
import parser from 'html-react-parser';

const plansPicture = [map1, map3];

const EventDetail = () => {
  const navigate = useNavigate();
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);
  const { user, isLogin } = useSelector((state) => state?.authReducer);
  const { currency } = useSelector((state) => state.converterReducer);

  const { t } = useTranslation('eventDetail');
  const { t: tCommon } = useTranslation('webCommon');

  const slug = useParams()?.slug;
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  const [searchParams] = useSearchParams();
  const adminToken = searchParams.get('token') || '';

  const { data, isLoading, refetch } = useGetPublicEventsDetailQuery({
    slug: `${slug}?token=${adminToken || ''}`
  });
  const [onFavorite, { isLoading: isFavoriting }] = useFavoriteEntityMutation();

  const eventData = data?.data;
  const isFavorite = eventData?.favoriteBy?.includes(user?._id);

  const { allBanners } = useSelector((state) => state.commonReducer);

  const tabsData = [
    {
      icon: <ReactSVG src={PhotoIcon} size={20} />,
      id: '1',
      value: 'Photos',
      tooltipText: t('tabs.photos')
    },
    {
      icon: <ReactSVG src={MapMarkerIcon} size={20} />,
      id: '4',
      value: 'Location',
      tooltipText: t('tabs.location')
    },
    {
      icon: <ReactSVG src={StreetViewIcon} size={20} />,
      id: '5',
      value: 'Street',
      tooltipText: t('tabs.streetView')
    },
    {
      icon: <ReactSVG src={VideoIcon} size={20} />,
      id: '6',
      value: 'Video',
      disabled: !eventData?.videoLink,
      tooltipText: t('tabs.video')
    }
  ];
  const [tabValue, setTabValue] = useState(tabsData[0]);

  const verticalBanners = allBanners?.filter(
    (item) => item?.page === 'event-detail' && item?.bannerType == 'vertical'
  );
  const horizontalBanners = allBanners?.find(
    (item) => item?.page === 'event-detail' && item?.bannerType == 'horizontal'
  );

  const handleFavorite = async () => {
    if (isFavoriting) return;
    const res = await onFavorite({ id: eventData?._id, type: 'event' });
    if (res?.data) {
      if (res?.data?.data?.favoriteBy?.includes(user?._id)) {
        toast.success(t('toast.addInFavList'));
      } else {
        toast.success(t('toast.removeFromFavList'));
      }
      refetch();
    }
  };

  const handleAction = () => {
    const isAllowedActions = restrictOnlyUserActions(user?.role);
    if (!isLogin) {
      navigate('/login');
    } else if (isAllowedActions) {
      return true;
    }
  };

  return (
    <>
      <Header containerClass="" />

      {isLoading ? (
        <Loader />
      ) : (
        <div className={classes.main}>
          <section className={classes.images}>
            <DetailPageHeroSection
              plansPicture={plansPicture}
              showLandMarks={false}
              images={eventData?.images ?? []}
              text={tabValue?.value}
              videoLink={eventData?.videoLink ?? ''}
              location={{
                lat: eventData?.location?.coordinates?.[1],
                lng: eventData?.location?.coordinates?.[0]
              }}
            />

            <div className={classes.socialIconsWrap1}>
              <div className={[classes.socialIcons1].join(' ')}>
                <BsShareFill onClick={() => setIsShareModalOpen(true)} fill="white" size={25} />
              </div>
              <div className={[classes.socialIcons1].join(' ')}>
                {isFavorite ? (
                  <AiFillHeart
                    onClick={() => {
                      if (!handleAction()) return;
                      handleFavorite();
                    }}
                    fill="var(--primary-clr)"
                    size={25}
                  />
                ) : (
                  <AiOutlineHeart
                    onClick={() => {
                      if (!handleAction()) return;
                      handleFavorite();
                    }}
                    fill="White"
                    size={35}
                  />
                )}
              </div>
              {/* <div className={[classes.socialIcons1].join(' ')}>
                  <IoMdPrint fill="var(--primary-clr)" size={25} />
                </div> */}
            </div>
          </section>
          <Container className={[classes.container].join(' ')}>
            <Row className={classes.gap}>
              <Col md={12} className={classes.BreadCrumsDiv}>
                <RenderBreadcrum data={eventData} type="event" />
              </Col>
              <Col md={12} lg={9} className={classes.col1}>
                <div className={classes.detailWrap}>
                  <div className={classes.priceRow}>
                    <div className={classes.mainImage}>
                      <img src={imageUrl(eventData?.company?.photo)} alt="" />
                    </div>
                    <div className="w-100">
                      <div className={classes.title}>
                        <p>{eventData?.name?.[selectedLanguage]}</p>
                        <div className={classes.mainTabsDiv}>
                          <Tabs
                            value={tabValue}
                            setValue={(e) => {
                              setTabValue(e);
                            }}
                            className={classes.tab}
                            tabsData={tabsData}
                            tabClass={classes.tab}
                          />
                        </div>
                      </div>
                      <div className={classes.price}>
                        <p>
                          {eventData?.price > 0
                            ? usdToOther({ amount: eventData?.price, ...currency })
                            : tCommon('eventCard.openInvitation')}
                        </p>
                      </div>
                      <div className={classes.desc}>
                        <p>{eventData?.title?.[selectedLanguage]}</p>
                      </div>

                      <div className={classes.addressWrap}>
                        <MdLocationOn color="#00A997" />
                        <p>{eventData?.address}</p>
                      </div>
                    </div>
                  </div>

                  <div className={classes.propertyDetailWrap}>
                    <div className={classes.propertyDetailWrapInner}>
                      <IconList
                        className={classes.infoIcons}
                        Icon={AiFillInfoCircle}
                        label={t('tooltips.eventType')}
                        value={eventData?.eventType?.title?.[selectedLanguage]}
                        iconSize={18}
                      />

                      <IconList
                        className={classes.infoIcons}
                        Icon={TbCalendarTime}
                        label={t('tooltips.dateOfEvent')}
                        value={moment(eventData?.eventDate).format('ll')}
                      />
                    </div>

                    {eventData?.pdf && (
                      <Button
                        className={classes.btn}
                        leftIcon={<BsDownload />}
                        onClick={() => {
                          downloadFileFromURL(pdfUrl(eventData?.pdf), eventData?.pdfName);
                        }}>
                        {t('downloadBrochure')}
                      </Button>
                    )}
                  </div>

                  <div className={classes.description}>
                    <HeadingWithUnderline underlineColor="var(--secondary-clr)">
                      <h5>{t('description')}</h5>
                    </HeadingWithUnderline>

                    <p>
                      {eventData?.description?.[selectedLanguage] &&
                        parser(eventData?.description?.[selectedLanguage])}
                    </p>
                  </div>
                  <div className={classes?.bannerAdContainer}>
                    {horizontalBanners?.image && (
                      <BannerImageAd
                        image={imageUrl(horizontalBanners?.image)}
                        className={classes.horizontalBanner}
                        link={horizontalBanners?.link}
                      />
                    )}
                  </div>
                </div>
              </Col>
              {/* Right column */}
              <Col md={12} lg={3} className={classes.col2}>
                <div className={classes.clientCard}>
                  <ClientManagerCard dataType={'event'} data={eventData} pageData={eventsData} />
                </div>
                <div className={classes?.bannerAdContainer}>
                  {verticalBanners?.map((item, key) => (
                    <BannerImageAd
                      key={`${item?._id}-${key}`}
                      image={imageUrl(item?.image)}
                      className={classes.verticalBanner}
                      link={item?.link}
                    />
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
          {isShareModalOpen && <ShareModal show={isShareModalOpen} setShow={setIsShareModalOpen} />}
        </div>
      )}
      <Footer showDownload={false} />
    </>
  );
};

export default EventDetail;

